import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import {
  GuestUserProps,
  OrderAddressProps,
  OrderOriginEnum,
  OrderProps,
  OrderTypeEnum,
} from '../types';
import ordersKeys from '../util/orders-keys';
import {CartPaymentProps} from 'modules/cart/types';
import useCart from 'modules/cart/util/use-cart';

interface CreateOrderAdditionalProps {
  id: string;
  quantity: number;
}

interface CreateOrderAdditionalGroupConfigProps {
  id: string;
  additionals: CreateOrderAdditionalProps[];
}

export interface CreateOrderProductProps {
  id: string;
  size?: string;
  saleId?: string;
  quantity: number;
  additionalGroups?: CreateOrderAdditionalGroupConfigProps[];
  observation?: string;
}

export interface CreateOrderProps {
  address?: OrderAddressProps;
  payment: CartPaymentProps;
  products: CreateOrderProductProps[];
  userId?: string;
  guestUser?: GuestUserProps;
  origin: OrderOriginEnum;
  type: OrderTypeEnum;
  companyId: string;
  total: number;
  document?: string;
  polyline: string;
  deliveryPrice: number;
  deliveryManFee: number;
  freeDelivery: boolean;
  observation?: string;
  retainedEarnings?: boolean;
}

const useCreateOrder = () => {
  const {create} = useInfiniteQueryHelpers();
  const {clearCart} = useCart();

  const onSuccess = (data: OrderProps) => {
    create(ordersKeys.list(), data);
    clearCart();
  };

  return useApiMutation<CreateOrderProps>({
    url: '/orders',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar pedido',
    successTitle: 'Cadastrar pedido',
    successMessage: 'Pedido cadastrada com sucesso',
    redirectUrl: '/orders',
    onSuccess,
  });
};

export default useCreateOrder;
